import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  contains: {
    description: 'filterOptions.contains',
    defaultMessage: 'Contains',
    id: 'ogVa2I',
  },
  doesNotContain: {
    description: 'filterOptions.doesNotContain',
    defaultMessage: 'Does Not Contain',
    id: 'uFq+Sj',
  },
  isBlank: {
    description: 'filterOptions.isBlank',
    defaultMessage: 'Is Blank',
    id: 'NcERE6',
  },
  isNotBlank: {
    description: 'filterOptions.isNotBlank',
    defaultMessage: 'Is Not Blank',
    id: '+MuCyq',
  },
  equals: {
    description: 'filterOptions.equals',
    defaultMessage: 'Equals',
    id: 'q3lSTg',
  },
  doesNotEqual: {
    description: 'filterOptions.doesNotEqual',
    defaultMessage: 'Does Not Equal',
    id: 'TtkMIh',
  },
  startsWith: {
    description: 'filterOptions.startsWith',
    defaultMessage: 'Starts With',
    id: '6wSWQ+',
  },
  doesNotStartWith: {
    description: 'filterOptions.doesNotStartWith',
    defaultMessage: 'Does Not Start With',
    id: 'EDgSar',
  },
  endsWith: {
    description: 'filterOptions.endsWith',
    defaultMessage: 'Ends With',
    id: 'nqo9Tl',
  },
  doesNotEndWith: {
    description: 'filterOptions.doesNotEndWith',
    defaultMessage: 'Does Not End With',
    id: 'TjMsCo',
  },
  greaterThan: {
    description: 'filterOptions.greaterThan',
    defaultMessage: 'Greater Than',
    id: '92EUTQ',
  },
  greaterThanOrEqualTo: {
    description: 'filterOptions.greaterThanOrEqualTo',
    defaultMessage: 'Greater Than Or Equal To',
    id: 'eOXkgh',
  },
  lessThan: {
    description: 'filterOptions.lessThan',
    defaultMessage: 'Less Than',
    id: 'sX3yj/',
  },
  lessThanOrEqualTo: {
    description: 'filterOptions.lessThanOrEqualTo',
    defaultMessage: 'Less Than Or Equal To',
    id: 'wX0frf',
  },
  equalTo: {
    description: 'filterOptions.equalTo',
    defaultMessage: 'Equal To',
    id: 'FSn/Cf',
  },
  notEqualTo: {
    description: 'filterOptions.notEqualTo',
    defaultMessage: 'Not Equal To',
    id: 'RVVAFr',
  },
  dateToday: {
    description: 'filterOptions.dateToday',
    defaultMessage: 'Today',
    id: '/FJRZy',
  },
  dateYesterday: {
    description: 'filterOptions.dateYesterday',
    defaultMessage: 'Yesterday',
    id: 'X+rwKW',
  },
  dateLastWeek: {
    description: 'filterOptions.dateLastWeek',
    defaultMessage: 'In the Last 7 Days',
    id: 'dD1kN7',
  },
  dateLast30Days: {
    description: 'filterOptions.dateLast30Days',
    defaultMessage: 'In the Last 30 days',
    id: 'RJuGH7',
  },
  dateOnOrBefore: {
    description: 'filterOptions.dateOnOrBefore',
    defaultMessage: 'On or Before',
    id: 'Ej9WNZ',
  },
  dateOnOrAfter: {
    description: 'filterOptions.dateOnOrAfter',
    defaultMessage: 'On or After',
    id: 'C8VPIk',
  },
  dateThisMonth: {
    description: 'filterOptions.dateThisMonth',
    defaultMessage: 'This Month',
    id: '0utxOE',
  },
  dateLastMonth: {
    description: 'filterOptions.dateLastMonth',
    defaultMessage: 'Last Month',
    id: 'Mlfx1s',
  },
  dateWithinThePastXDays: {
    description: 'filterOptions.dateWithinThePastXDays',
    defaultMessage: 'Within The Past X Days',
    id: 'mw77Km',
  },
  dateWithinTheNextXDays: {
    description: 'filterOptions.dateWithinTheNextXDays',
    defaultMessage: 'Within The Next X Days',
    id: 'rDqDbY',
  },
  dateXDaysAgoOrMore: {
    description: 'filterOptions.dateXDaysAgoOrMore',
    defaultMessage: 'X Days Ago Or More',
    id: '3J/PlJ',
  },
  dateXDaysAheadOrMore: {
    description: 'filterOptions.dateXDaysAheadOrMore',
    defaultMessage: 'X Days Ahead Or More',
    id: 'LWpkI/',
  },
  dateCustomRange: {
    description: 'filterOptions.dateCustomRange',
    defaultMessage: 'Custom Range',
    id: 'GfB7SV',
  },
  is: {
    description: 'filterOptions.is',
    defaultMessage: 'Is',
    id: 'e0Cl0b',
  },
  isNot: {
    description: 'filterOptions.isNot',
    defaultMessage: 'Is Not',
    id: '8x6Y3s',
  },
  empty: {
    description: 'filterOptions.empty',
    defaultMessage: 'Is Blank',
    id: '+qTrbo',
  },
  notEmpty: {
    description: 'filterOptions.notEmpty',
    defaultMessage: 'Is Not Blank',
    id: 'Vq9MPg',
  },
  unassigned: {
    description: 'filterOptions.optionNameUnassigned',
    defaultMessage: 'Unassigned',
    id: '83AWdU',
  },
  deleted: {
    description: 'filter options - specify a rate shopper is deleted',
    defaultMessage: 'Deleted',
    id: 'Cbn90N',
  },
});
